import React 			from 'react';
import PropTypes 	from 'prop-types';

export default class HeroSlider extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			active: 0,
			pause: false
		}
	}

	componentDidMount() {
		if(this.props.items.length > 1) { 
			this.startSlider();
		}

		const slider = this.slider;

		if(this.state.pause == false) {
			slider.addEventListener('mouseover', () => {
				this.setState({pause: true});
			});
		}
		slider.addEventListener('mouseout', () => {
			this.setState({pause: false});
		});
	}

	render() {
		const {classes = '', items, speed} = this.props;
		const slides = items.map((item, key) => this.renderSlide(key, item));

		return (
			<div ref={slider => this.slider = slider} className={"hero-slider edge-to-edge-container" + classes}>
				<div className="hero-slider__slides" style={{transform: `translateX(-${this.state.active * 100}%)`}}>
					{slides}
				</div>
				{this.props.items.length > 1 ? this.renderPagination() : null}
			</div>
		);
	}

	renderSlide(key, item) {
		return (
			<div key={key} className={"hero-slider__item"} style={{backgroundImage: `linear-gradient( 90deg, #${item.strBGColorLeft} 0%, #${item.strBGColorLeft} 50%, #${item.strBGColorRight} 50%, #${item.strBGColorRight} 100% )`}}>
				<div className="edge-to-edge-container__internal edge-to-edge-container__internal--tight-mob">
					<a href={item.strLinkUrl}>
						<picture className="hero-slider__image">
							<source media="(min-width:840px)" srcSet={blapp.url2.getUrlFromFileInfo(item.fiMain)}/>
							<source media="(min-width:640px)" srcSet={item.fiMedium ? blapp.url2.getUrlFromFileInfo(item.fiMedium) : (item.fiSmall ? blapp.url2.getUrlFromFileInfo(item.fiSmall) : blapp.url2.getUrlFromFileInfo(item.fiMain))}/>
							<source srcSet={item.fiSmall ? blapp.url2.getUrlFromFileInfo(item.fiSmall) : (item.fiMedium ? blapp.url2.getUrlFromFileInfo(item.fiMedium) : blapp.url2.getUrlFromFileInfo(item.fiMain))}/>
							<img src={blapp.url2.getUrlFromFileInfo(item.fiMain)} alt={item.strAltText}/>
						</picture>
					</a>
				</div>
			</div>
		);
	}

	renderPagination() {
		const slides 					= this.props.items;
		const paginationDots 	= slides.map((image, key) => <button className={"hero-slider__pagination-dot" + (key == this.state.active ? ' hero-slider__pagination-dot--active' : '')} onClick={() => this.goToSlide(key)}>{key}</button>)

		return (
			<nav className="hero-slider__pagination-container">
				<div className="hero-slider__pagination-internal">
					<div className="hero-slider__pagination">
						{paginationDots}
					</div>
				</div>
			</nav>
		);
	}

	goToSlide(key) {
		const prevActive = this.state.active;

		this.setState({active: key, prevActive: prevActive});
	}

	startSlider() {
		const speed = this.props.speed || 3000;

		setTimeout(() => {
			const items 	= this.props.items;
			const active 	= this.state.active + 1 == items.length ? 0 : this.state.active + 1;

			if(!this.state.pause) {
				this.setState({active: active});
			}

			this.startSlider();
		}, speed);
	}

}

HeroSlider.propTypes = {
		classes: PropTypes.string
	,	items: PropTypes.number.isRequired
	,	speed: PropTypes.number
}